import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Home.css';

const Home: React.FC = () => {
  useEffect(() => {
    document.body.classList.add('home');
    return () => {
      document.body.classList.remove('home');
    };
  }, []);

  const carouselImages = [
    { src: '/images/1-2008-audi-r8-940x380.jpg', alt: 'Audi R8' },
    { src: '/images/i8_left-side-940x380.jpg', alt: 'BMW i8 Hybrid' },
    { src: '/images/AMG_Engine-940x380.jpg', alt: 'Mercedes M157 Engine' },
    { src: '/images/bug-attiveyron-insides-940x380.jpg', alt: 'Bugatti Veyronin' },
    { src: '/images/Porsche-911-Cars-Wallpaper-Background-940x380.jpg', alt: 'Porsche GT3' },
    { src: '/images/Porsche-911-Gt3-Rs-3-Hd-Desktop-Wallpaper.jpg', alt: 'Porsche_GT2' },
    { src: '/images/Ferrari_Laferrari-940x380.gif', alt: 'La_Ferrari' },
    { src: '/images/mb_cl_display.gif', alt: 'Mercedes_CL' },
    { src: '/images/lambo_venano_display.gif', alt: 'Lambo_Performance' },
    { src: '/images/porsche_cayman_cars-wide-940x380.jpg', alt: 'Porsche in the Streets' },
  ];



  return (
    <div id="wrap">
      {/* Home Top Section */}
      <div id="home-top">
        <div className="home-top-shadow"></div>
        
        <div className="home-top-left">
          <div className="wrap">
            <div className="widget widget_text">
              <div className="widget-wrap">
                <h4 className="widget-title">AEuromotive Forum</h4>
                <div className="textwidget">
                  <p>
                    Join the AEuromotive Forum for access to the Latest Diagnostic Technical Library, 
                    Technical/Service Information, A Dynamic Forum of Professional Automotive Technicians, 
                    Online Video Training and more.
                  </p>
                  <p>
                    Check us out at{' '}
                    <a href="http://forum.aeuromotive.com/" target="_blank" rel="noopener noreferrer">
                      forum.aeuromotive.com
                    </a>{' '}
                    or give us a call at 800-660-7156.
                  </p>
                  <p>
                    <a href="https://www.aeuromotive.com/?page_id=35" className="more-link">
                      READ MORE
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="home-top-right">
          <div className="wrap">
            <div className="widget widget_carousel">
              <div className="widget-wrap">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={0}
                  slidesPerView={1}
                  navigation
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  className="carousel-swiper"
                >
                  {carouselImages.map((image, index) => (
                    <SwiperSlide key={index}>
                      <img src={image.src} alt={image.alt} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        
        <div className="clear"></div>
      </div>

      {/* Home Middle Section */}
      <div id="home-middle">
        <div className="home-middle-top"></div>
        <div className="wrap">
          <div className="widget widget_text">
            <div className="widget-wrap">
              <h4 className="widget-title">Manufactures Technical Information Websites</h4>
            </div>
          </div>
          <div className="clear"></div>
        </div>
        <div className="home-middle-bottom"></div>
        <div className="clear"></div>
      </div>

      {/* Home Bottom Section */}
      <div id="home-bottom">
        <div className="home-bottom-1">
          <div className="wrap">
            <div className="widget widget_image">
              <div className="widget-wrap">
                <h4 className="widget-title">ONLINE Training & Manuals</h4>
                <Link to="/system-manuals">
                  <img 
                    src="/images/12-9-2014-9-14-13-AM-600x359.png" 
                    alt="Online Training" 
                    style={{ maxWidth: '100%', height: 'auto' }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="home-bottom-2">
          <div className="wrap">
            <div className="widget widget_image">
              <div className="widget-wrap">
                <a href="https://forum.aeuromotive.com/register?noPurchase=1" target="_blank" rel="noopener noreferrer">
                  <img 
                    src="/images/Free30DayTrial.png" 
                    alt="Free 30 Day Trial" 
                    style={{ maxWidth: '100%', height: 'auto' }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="home-bottom-3">
          <div className="wrap">
            <div className="widget widget_image">
              <div className="widget-wrap">
                <h4 className="widget-title">ISTA Information</h4>
                <Link to="/ista-desktop-computer">
                  <img 
                    src="/images/ISTA-Portal-1-600x472.jpg" 
                    alt="ISTA Portal" 
                    style={{ maxWidth: '100%', height: 'auto' }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

